import S from "./index.module.scss";
import { FC } from "react";
import { useTranslations } from "next-intl";
import { ButtonLink } from "@/components/ui/button";
import Header from "@/components/entities/header";

type ErrorProps = {
  title?: string;
  text: string;
};

const Error: FC<ErrorProps> = ({ title, text }) => {
  const t = useTranslations();

  return (
    <div>
      <Header variant="default" />
      <div className={S.wrapper}>
        <h1 className={S.title}>{title ?? t("error.wrong")}</h1>
        <p className={S.text}>{text}</p>
        <ButtonLink variant="trBlackToBlack" href="/">
          {t("home.backHome")}
        </ButtonLink>
      </div>
    </div>
  );
};

export default Error;
